// extracted by extract-css-chunks-webpack-plugin
module.exports = {"YcCoin":"KiNAN58S"};